
import { defineComponent } from 'vue'
// todo test the error message upcoming
export default defineComponent({
  inject: ['GStore']
})
